<template>
  
</template>

<script>
export default {
    name: "StokDetay"
}
</script>
